import React from 'react';
import '../../../../css/FactSheets.css';
import { ContactInfo } from '../../../Common/ContactInfo';
import './ContactUsBlock.css';

import config from "../../../../config/config.json";

export interface ContactUsBlockProps {
    variant?: string
}

export const ContactUsBlock = (props: ContactUsBlockProps) => {
    const { variant } = props;

    
    return (
        <>
            <ContactInfo
                text={"If you would like more information, please contact the " + config.ServicesAustralia_TEAM +" at Services Australia."}
                textWidth="42.1875rem"
                hasPadding
                violet={(variant === "violet")}
            />
        </>
    );
}